export type BillingTier = "free" | "essentials" | "professional" | "unlimited";

export interface WorkspaceEntitlements {
  tier: BillingTier;
  maxAudits: number | "unlimited";
  maxMembers: number | "unlimited";
  maxWorkspaces: number | "unlimited";
  maxStorageMb: number | "unlimited";
  hasTemplates: boolean;
  hasApiAccess: boolean;
  hasPrioritySupport: boolean;
  hasGapAnalysisAutoFix: boolean;
  hasPredictiveCompliance: boolean;
  hasAiReports: boolean;
  hasByoa: boolean;
  hasCustomerManager: boolean;
}

export const PLAN_LIMITS: Record<BillingTier, WorkspaceEntitlements> = {
  free: {
    tier: "free",
    maxAudits: 1,
    maxMembers: 1,
    maxWorkspaces: 1,
    maxStorageMb: 500,
    hasTemplates: false,
    hasApiAccess: false,
    hasPrioritySupport: false,
    hasGapAnalysisAutoFix: false,
    hasPredictiveCompliance: false,
    hasAiReports: false,
    hasByoa: false,
    hasCustomerManager: false,
  },
  essentials: {
    tier: "essentials",
    maxAudits: 3,
    maxMembers: 1,
    maxWorkspaces: 1,
    maxStorageMb: 2000,
    hasTemplates: true,
    hasApiAccess: false,
    hasPrioritySupport: false,
    hasGapAnalysisAutoFix: false,
    hasPredictiveCompliance: false,
    hasAiReports: true,
    hasByoa: false,
    hasCustomerManager: false,
  },
  professional: {
    tier: "professional",
    maxAudits: 5,
    maxMembers: 5,
    maxWorkspaces: 3,
    maxStorageMb: 10000,
    hasTemplates: true,
    hasApiAccess: false,
    hasPrioritySupport: true,
    hasGapAnalysisAutoFix: true,
    hasPredictiveCompliance: false,
    hasAiReports: true,
    hasByoa: false,
    hasCustomerManager: false,
  },
  unlimited: {
    tier: "unlimited",
    maxAudits: "unlimited",
    maxMembers: 25,
    maxWorkspaces: "unlimited",
    maxStorageMb: "unlimited",
    hasTemplates: true,
    hasApiAccess: true,
    hasPrioritySupport: true,
    hasGapAnalysisAutoFix: true,
    hasPredictiveCompliance: true,
    hasAiReports: true,
    hasByoa: true,
    hasCustomerManager: true,
  },
};
